<template>
	<div>
		<div class="fullPageContent closed">
			<DashboardHeader
				v-bind:showMobileRightMenu="false"
				v-bind:title="pageTitle"
				v-bind:activeEl="activeEl"
				v-bind:tabs="tabs"
				@tabSelectedChange="tabSelectedChange($event)"
				ref="dashboardHeader"
			/>
			<section class="allP wp1200">
				<div class="content">
					<div v-if="isActive === 1">
						<AwardPage />
					</div>
					<!-- <div v-if="isActive === 2">
						<AwardPageGold />
					</div> -->
					<div v-if="isActive === 3">
						<AwardPageWelness />
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import DashboardHeader from './partials/DashboardHeader.vue';
import AwardPage from "@/components/AwardPage/AwardPage";
import AwardPageGold from "@/components/AwardPage/AwardPageGold";
import AwardPageWelness from "@/components/AwardPage/AwardPageWelness";

export default {
	data() {
		return {
			activeEl: null,
			pageTitle: this.$t("awardPage.main_title"),
			tabs:[
				{
					index:1,
					name:'Splošna pravila sodelovanja'
				},
				// {
				// 	index:2,
				// 	name:'Zlata vreden klub'
				// },
				{
					index:3,
					name:'Oddih v termah'
				}
			],
			isActive:1,
		};
	},
	computed: {},
	components: {
		AwardPage,
		// AwardPageGold,
		AwardPageWelness,
		DashboardHeader,
	},
	mounted() {
		this.$store.dispatch("app/loader", false);
		this.goldActive();
		this.wellnessActive();
	},
	methods: {
		goldActive(){
			if(this.$route.query.page === 'gold'){
				this.tabSelectedChange(2);
				this.$refs.dashboardHeader.tabActive = 2;
			}
		},
		wellnessActive(){
			if(this.$route.query.page === 'wellness'){
				this.tabSelectedChange(3);
				this.$refs.dashboardHeader.tabActive = 3;
			}
		},
		tabSelectedChange(active) {
			this.isActive = active;
		},
	},
};
</script>

<style>
.vue-typer .custom.char.typed {
	color: #ffffff;
}

.vue-typer .custom.caret {
	display: none;
}
</style>